module.exports = __webpack_public_path__ + "img/holiday-jumble-banner-600w.77bc0f95.jpg";